<template>

    <v-panel title="Headline">
        <v-section-text expanded />
        <v-section name="Color">
            <v-action-color type="color" />
            <v-action-color type="link-color" />
        </v-section>
        <v-section-block />
    </v-panel>

</template>

<script>

import ActionColor from './actions/ActionColor';
import Panel from './Panel';
import Section from './sections/Section';
import SectionBlock from './sections/SectionBlock';
import SectionText from './sections/SectionText';

export default {

    components: {
        'v-action-color': ActionColor,
        'v-panel': Panel,
        'v-section': Section,
        'v-section-block': SectionBlock,
        'v-section-text': SectionText,
    },

}

</script>